import notify from '@/notify'
import router from '@/routes'
import store from '@/store'

export default {
    get(url, params = {}) {
        return axios({
            method: 'get',
            url: url,
            params: params,
            headers: {'Authorization': 'Bearer ' + store.token}
        })
            .then(this.handleSuccess)
            .catch(this.handleError)
    },

    post(url, data, options = {}) {
        return axios({
            method: 'post',
            url: url,
            data: data,
            headers: {'Authorization': 'Bearer ' + store.token},
            ...options
        })
            .then(this.handleSuccess)
            .catch(this.handleError)
    },

    delete(url) {
        return axios({
            method: 'delete',
            url: url,
            headers: {'Authorization': 'Bearer ' + store.token}
        })
            .then(this.handleSuccess)
            .catch(this.handleError)
    },

    patch(url, data) {
        return axios({
            method: 'patch',
            url: url,
            data: data,
            headers: {'Authorization': 'Bearer ' + store.token}
        })
            .then(this.handleSuccess)
            .catch(this.handleError)
    },

    put(url, data) {
        return axios({
            method: 'put',
            url: url,
            data: data,
            headers: {'Authorization': 'Bearer ' + store.token}
        })
            .then(this.handleSuccess)
            .catch(this.handleError)
    },

    request(params) {
        return axios(Object.assign(params, {headers: {Authorization: 'Bearer ' + store.token}}))
            .then(this.handleSuccess)
            .catch(this.handleError)
    },

    getCredentials(callback) {
        this.get('/api/v1/me')
            .then(response => {
                store.user = response.data.data.subject

                localStorage.setItem('user', JSON.stringify(response.data.data.subject))

                notify.success(callback(response.data.data.subject))

                router.push('/dashboard')
            })
    },

    getList(url, params = {}) {
        return new Promise((resolve) => {
            this.getNextPage(url, params, 1, [], resolve)
        })
    },

    getNextPage(url, params, page, items, resolve) {
        this.get(url, { ...params, page }).then((response) => {
            items = items.concat(response.data.data)

            if (response.data.meta.current_page === response.data.meta.last_page) {
                return resolve(items)
            }

            return this.getNextPage(url, params, page + 1, items, resolve)
        })
    },

    handleSuccess(response) {
        if(typeof response.headers['authorization'] !== 'undefined') {
            store.token = response.headers['authorization'].substr(7)

            localStorage.setItem('token', response.headers['authorization'].substr(7))
        }

        return response
    },

    handleError(error) {
        if(axios.isCancel(error)) {
            throw error
        }

        if (error.response.status === 401) {
            notify.error('Your session has expired')

            return router.push('/login')
        }

        throw error
    }
}
